/**
 * Mulberry32 seeded PRNG.
 * Given the same seed, always produces the same sequence of random numbers.
 * Used for deterministic factory generation.
 */
export function createRNG(seed: number): () => number {
    let state = seed | 0
    return function (): number {
        state = (state + 0x6d2b79f5) | 0
        let t = Math.imul(state ^ (state >>> 15), 1 | state)
        t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296
    }
}
